import type { ActionOutput } from './protocol'

export interface ActionSummary {
    /** Sats paid to the viewer's own address. */
    receive: number
    /** Sats the viewer's wallet adds, before the network fee. */
    walletPays: number
    /** Sats going to outputs that aren't the viewer's, beyond what the ordinal's inputs cover:
     * what the viewer's money funds somewhere else. */
    elsewhere: number
}

/** How the viewer's own money moves in an action. Without a known input value it assumes the
 * inputs bring nothing, so it can only overstate what the viewer pays or sends elsewhere. */
export function actionSummary(
    outputs: ActionOutput[],
    inputSats: number | null,
    ownOutputs: Set<number>,
): ActionSummary {
    let receive = 0
    let others = 0
    outputs.forEach((output, index) => {
        if (ownOutputs.has(index)) receive += output.satoshis
        else others += output.satoshis
    })
    const covered = inputSats ?? 0
    return {
        receive,
        walletPays: Math.max(0, receive + others - covered),
        elsewhere: Math.max(0, others - covered),
    }
}
